module.exports = __webpack_public_path__ + "static/media/26.396365b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/26.png
// module id = 1465
// module chunks = 0